import React from 'react';
import './App.scss';
import { BrowserRouter as Router } from 'react-router-dom';
import { AppRoutes } from 'src/shared/utils/routes';

function App() {
  return (
    <Router>
      <AppRoutes />
    </Router>
  );
}

export default App;
